import { render } from "./endGame.vue?vue&type=template&id=02cb9010"
import script from "./endGame.vue?vue&type=script&lang=js"
export * from "./endGame.vue?vue&type=script&lang=js"

import "./endGame.vue?vue&type=style&index=0&id=02cb9010&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__